export default __webpack_public_path__ + "static/media/benefit_0.668e3454.svg";